
























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Info from '@/components/task/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import StaffInfo from '@/components/task/StaffInfo.vue'
import CancelApply from '@/components/task/CancelApply.vue'
import ImageInfo from '@/views/AiiTasks/ImageInfo.vue'
import RelationOrders from '@/views/AiiTasks/RelationOrders.vue'
import RecordSection from '@/components/task/RecordSection.vue'
import ImageUploads from './ImagesUploads.vue'

@Component({
	components: {
		Info,
		InfoRow,
		StaffInfo,
		CancelApply,
		ImageInfo,
		RelationOrders,
		RecordSection,
		ImageUploads,
	},
})
export default class otherInvestigateTab extends Vue {
	private taskInfo: any = []
	private staffInfo: any = []
	private operatorCancelReasonInfo: any = false
	private operatorCancelHistoryInfo: any = false
	private imageBlocks = [
		{
			name: '调查授权',
			type: '0d01',
		},
		{
			name: '被调查人身份证复印件',
			type: '0f01',
		},
		{
			name: '其他（可选）',
			type: '0900',
		},
	]
	private mediaMap: any = {}

	@Prop()
	public task!: any

	@Prop()
	public injured!: any

	@Prop()
	public order!: any

	@Prop()
	private activeKey!: any

	@Prop()
	private show!: any

	private get supplyInfo() {
		if (['01', '02', '03'].includes(this.order.orderStatus)) {
			if (this.order.returnFlag === '1') {
				return '（待作业人员重新补录）'
			}
			return '（待作业人员补录）'
		}
		return ''
	}

	@Watch('task', { immediate: true })
	private onTaskChange() {
		if (!this.task) {
			return
		}
		this.taskInfo = this.task.getTaskInfo()
		this.staffInfo = this.task.getStaffInfo()

		this.operatorCancelReasonInfo = this.task.getOperatorCancelReasonInfo()
		this.operatorCancelHistoryInfo = this.task.getOperatorCancelHistoryInfo()
		if (this.order && this.order.imageList) {
			const mediaMap: any = {}
			this.order.imageList.forEach((imgObj: any) => {
				if (!mediaMap[imgObj.type]) {
					mediaMap[imgObj.type] = []
				}
				mediaMap[imgObj.type].push({ ...imgObj })
			})
			this.mediaMap = mediaMap
		}
	}
}
